module.exports = __webpack_public_path__ + "img/banner-1.e2ab1e7f.jpg";